import { EulaUtils } from "../../utils/_EulaUtils";

EulaUtils.faq("faq_section");
$(() => {});
